$(function () {
    // type video upload
    $(".section.video .play-upload").click(function (e) {
        $(this).hide();
        $(".section.video .close").show();
        $(".section.video .thumbnail").hide();
        $(".section.video .video-play-container").show();
        var video = document.getElementById("video-upload");
        video.play();
    });
    // close upload
    $(".section.video .close-upload").click(function (e) {
        $(this).hide();
        $(".section.video .play").show();
        $(".section.video .thumbnail").show();
        $(".section.video .video-play-container").hide();
        var video = document.getElementById("video-home");
        video.stop();
    });
    // youtube
    $(".section.video .play-youtube").click(function (e) {
        $(this).hide();
        $(".section.video .close").show();
        $(".section.video .thumbnail").hide();
        $(".section.video .video-play-container").show();
        var thisYtId = $(this)
            .data("youtube")
            .replace("https://www.youtube.com/watch?v=", "");
        autoPlayVideo(thisYtId);
        //document.getElementById("video-youtube").src += "&autoplay=1";
        //document.getElementById("video-youtube").click();
    });
    // close youtube
    $(".section.video .close-youtube").click(function (e) {
        $(this).hide();
        $(".section.video .play").show();
        $(".section.video .thumbnail").show();
        $(".section.video .video-play-container").hide();
        $("#video-youtube").attr("src", $("iframe").attr("src"));
    });
});

function autoPlayVideo(thisYtId) {
    "use strict";
    $("#video-youtube-container").html(
        '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' +
            thisYtId +
            '?autoplay=1&mute=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>',
    );
}
